<template>
    <div class="payment__form">
        <div
            v-if="state.currentView == 'PAGA_INIT_VIEW' && state.processing != true"
        >
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{$t("paga.init.instruction")}}
            </p>
            <PrimaryButton :content="$t('paga.pay.btn')" @click="nextStep" />
        </div>
        <template
            v-else-if="
                state.currentView == 'REDIRECT_VIEW' && state.processing != true
            "
        >
            <div class="redirect-wrapper">
                <div class="redirect-icon--arrow">
                    <svg width="33" height="27" viewBox="0 0 33 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.1799 3.13007L18.5799 7.10007L24.7999 6.47007L13.2599 20.5301L4.15988 13.1301L1.62988 16.2201L13.8299 26.1301L27.9799 8.89007L28.6199 15.2501L32.5999 14.8501L31.2799 1.82007L18.1799 3.13007Z" fill="#FFCA7D"/>
                        <path d="M17.0998 1.51996L17.4998 5.47996L23.7098 4.85996L12.1798 18.91L3.0898 11.52L0.549805 14.61L12.7498 24.52L26.8998 7.27996L27.5398 13.64L31.5198 13.24L30.1998 0.209961L17.0998 1.51996Z" fill="black"/>
                        <path d="M0.549805 14.61L1.6298 16.22L13.8298 26.13L12.7498 24.52L0.549805 14.61Z" fill="#703E00"/>
                        <path d="M17.5 5.47998L18.58 7.09999L22.18 6.72998L23.71 4.85999L17.5 5.47998Z" fill="#703E00"/>
                        <path d="M27.54 13.64L28.62 15.25L32.6 14.85L31.52 13.24L27.54 13.64Z" fill="#FFCA7D"/>
                        <path d="M30.1997 0.209961L31.2797 1.81996L32.5997 14.85L31.5197 13.24L30.1997 0.209961Z" fill="#703E00"/>
                    </svg>
                </div>
            </div>
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{$t("paga.redirect.instruction")}}
            </p>
            <PrimaryButton :content="$t('paga.continue.btn')" @click="nextStep" />
        </template>
    </div>
</template>

<script>
import PrimaryButton from "@/components/form/base-button";
import { getValueFromPath, autoInitialize } from "@/support/helpers";
import { injectStore, mapState } from "redux-vuex";
import { ref, onBeforeUnmount } from "vue";
import { onUpdated } from "@vue/runtime-core";

export default {
    name: "PagaPayment",
    components: {
        PrimaryButton,
    },
    setup() {
        const store = injectStore();
        const checkoutData = ref(store.getState());

        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        function nextStep() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }

        const autoInitializePayment = autoInitialize("PAGA_INIT_VIEW");

        onUpdated(() =>  autoInitializePayment(checkoutData, nextStep));

        onBeforeUnmount(() => {
            subscription();
        });

        return {
            state: mapState({
                processing: (state) => getValueFromPath(state, "processing") || false,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
            }),
            getValueFromPath,
            nextStep,
        };
    },
};
</script>

<style scoped>
</style>